import React from 'react';
import { CreditCardIcon, DownloadIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
const trustItems = [{
  icon: LockIcon,
  label: 'Pagamento sicuro'
}, {
  icon: DownloadIcon,
  label: 'Accesso immediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garanzia 7 giorni'
}, {
  icon: CreditCardIcon,
  label: 'Nessun abbonamento'
}];
export function Offer() {
  return <section id="offerta" className="w-full bg-surface px-5 py-14 sm:py-24" data-id="element-159" data-mp="u0xthpsq9wzt">
      <div className="mx-auto max-w-md" data-id="element-160" data-mp="p1bfvf8zmeqh">
        <div className="text-center" data-id="element-161" data-mp="13x17bswxzk2l">
          <span className="eyebrow-rule text-[10px] font-bold uppercase tracking-[0.2em] text-secondary sm:text-[11px]" data-id="element-162" data-mp="13y2g1qqhjuh5">
            Pagamento unico
          </span>
          <h2 className="mt-3 font-display text-[1.6rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.2rem]" data-id="element-163" data-mp="2fbxwr3x1gbah">
            Offerta di Lancio{' '}
            <span className="italic text-primary" data-id="element-164" data-mp="2af7hgit25jq4">Imbattibile</span>
          </h2>
        </div>

        <div className="relative mt-9 rounded-3xl border-2 border-primary bg-surface px-6 pb-6 pt-9 shadow-card sm:px-7 sm:pb-7" data-id="element-165" data-mp="pjz47x579lzu">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-primary px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-surface" data-id="element-166" data-mp="ziertq50qd4l">
            Pack Matematica Pronta
          </span>

          <img src="https://cdn.magicpatterns.com/uploads/75eENhcjp7iSxQxQ1ZswqE/Pack_educativo_Matematica_Pronta_para_docentes.webp" alt="Tutto il pack Matematica Pronta: 8 volumi, versione digitale e i 5 bonus" className="mx-auto mb-4 h-32 w-full object-contain sm:h-44" data-id="element-167" data-mp="6v0qzgy78xf7" />

          <dl className="text-[13px] sm:text-sm" data-id="element-168" data-mp="kle0hnqqok6n">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-foreground/10 py-2.5" data-id="element-169" data-mp="3k8m0kt4ww121">
                <dt className="text-foreground/75" data-id="element-170" data-mp="3o9fnbj6mb9tc">{row.label}</dt>
                <dd className="font-bold text-foreground" data-id="element-171" data-mp="vfqxu4aubgt9">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between gap-4 border-b border-foreground/10 py-2.5" data-id="element-172" data-mp="vde64zfa5s30">
              <dt className="font-bold uppercase tracking-wide text-foreground" data-id="element-173" data-mp="155k6awforfta">
                Valore totale
              </dt>
              <dd className="font-bold text-foreground/40 line-through" data-id="element-174" data-mp="1067avnar10f3">€241,95</dd>
            </div>
          </dl>

          <p className="mt-4 text-center text-[10px] font-extrabold uppercase tracking-[0.18em] text-secondary" data-id="element-175" data-mp="cho1f4fyqhlf">
            Oggi a soli
          </p>
          <p className="flex items-end justify-center gap-2 pb-4 pt-1" data-id="element-176" data-mp="lhkxhr4omiqi">
            <span className="font-display text-6xl font-black leading-none text-primary" data-id="element-177" data-mp="livwzer3h4bt">
              €19
            </span>
            <span className="pb-1.5 font-display text-lg font-bold text-foreground/35 line-through" data-id="element-178" data-mp="1wwpzeswzod92">
              €241,95
            </span>
          </p>

          <CtaButton label="Scarica Matematica Pronta ora" className="w-full" data-id="element-179" data-mp="1sul7pzq3pqp2" />

          <ul className="mt-5 grid grid-cols-2 gap-x-3 gap-y-2.5 border-t border-foreground/10 pt-5" data-id="element-180" data-mp="20dm31xqr0e1c">
            {trustItems.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-[11px] font-semibold text-foreground/65" data-id="element-181" data-mp="1qgzjrde2lv1f">
                <Icon className="h-3.5 w-3.5 shrink-0 text-secondary" aria-hidden="true" data-id="element-182" data-mp="1vglyjr9jrjcc" />
                {label}
              </li>)}
          </ul>

          <p className="mt-4 text-center text-[11px] leading-relaxed text-foreground/50" data-id="element-183" data-mp="2j7hmgdavtueb">
            Pagamento unico · Accesso illimitato · Soddisfatta o rimborsata
          </p>
        </div>
      </div>
    </section>;
}